
export { VRTX_TOKEN_INFO } from "/home/runner/work/stackd-perps/stackd-perps/packages/vertex-react-client/context/metadata/productMetadata/vrtxTokenInfo.ts"